import { injectable } from 'inversify'
import log from 'logging/logger'

export interface TokenProvider {
    (): Promise<string | undefined>
}

@injectable()
export class KibsiAuthConfigProvider {
    private tokenProvider?: TokenProvider

    async getAuthorization(): Promise<string | undefined> {
        const token = await this.internalTokenProvider()

        return getAuthHeader(token)
    }

    /**
     * Hook to set the token provider from an external source, i.e. from react or an auth sdk
     */
    setTokenProvider(provider: TokenProvider): void {
        log.info(`setting token provider`)
        this.tokenProvider = provider
    }

    /**
     * This is the internal token provider from the wrapper.
     */
    private async internalTokenProvider(): Promise<string | undefined> {
        if (this.tokenProvider) {
            return this.tokenProvider()
        }

        log.warn('token provider does not exist')

        return undefined
    }
}

function getAuthHeader(token?: string): string | undefined {
    if (token) {
        return `Bearer ${token}`
    }

    return undefined
}
